jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});

// <================================property of specific products==================================>
var inputText = document.querySelector('.cstm_personalize_text');
var inputProperty = document.querySelectorAll('.cstm_propertiesInput');
var inputPropertyGift = document.querySelectorAll('.cstm_propertiesInputGift');
var pdpInput = document.querySelectorAll('.font_family_text');
var selectedPdpInput = document.querySelectorAll('.font_family_text.cstm-selected');
var personalizeBtn = document.querySelector('.cstm_personizeTextbtn');
var QVpersonalizeBtn = document.querySelector('.t4s-modal__inner .cstm_personizeTextbtn');
var options = document.querySelectorAll('.font_family_YN');
var optionstext = ""; 
var giftText = document.querySelector('.cstm_personalize_gift');
var personalizePreview = document.querySelector('.preview_text');
var personalizeInput = document.querySelector('.previewPersonalize_input');
var confirmBtn = document.querySelector('.cstm_confirm_personalization');
var pdpPreviewText = document.querySelector('.personalize_text_prview');
var pdpPreviewFont = document.querySelector('.personalize_font_prview');
var pdpPreviewGift = document.querySelector('.personalize_GiftMsg_prview');
var pdpPreviewGiftYN = document.querySelector('.personalize_YN_prview');


options.forEach((optionss) => {
  optionss.addEventListener('click', () => {
    optionstext = optionss.innerText; 
    pdpPreviewGiftYN.innerHTML = "<strong>Is this a gift? ADD GIFT BOX AND A CUSTOM NOTE: </strong>" + " " + optionstext;
  });
});

pdpInput.forEach((pdpInputs) => {
  pdpInputs.addEventListener('click', () => {
    pdpInput.forEach((element) => {
      element.classList.remove('cstm-selected');
    });
    pdpInputs.classList.add('cstm-selected');
    var family_text = pdpInputs.getAttribute('font');
    inputText.style.fontFamily = family_text;
    personalizePreview.style.fontFamily = family_text;
    pdpPreviewText.innerHTML = "<strong>Personalization:</strong> " +  " " +  inputText.value;
    pdpPreviewFont.innerHTML = "<strong>Choosen Font:</strong> " +   " " + pdpInputs.innerText;
    for (var i = 0; i < inputProperty.length; i++) {
      inputProperty[0].value = inputText.value;
      inputProperty[1].value = pdpInputs.innerText;
    }
  });
});


setTimeout(() => {
  // personalizeBtn.setAttribute('disabled', true); 

  // inputText.style.border = '1px solid #ff0000'
  // inputText.focus();
}, 1000); 

 inputText.addEventListener('input', () => {
   personalizePreview.innerText = inputText.value; 
    pdpPreviewText.innerHTML = "<strong>Personalization:</strong> " +  " " +  inputText.value;
    inputProperty[0].value = inputText.value;
  if (inputText.value.length > 0) {
    personalizeBtn.removeAttribute('disabled');
    inputText.style.border = '1px solid black'   
  } else {
    personalizeBtn.setAttribute('disabled', true);
    inputText.focus();
    inputText.innerText = "&nbps"
    inputText.style.border = '1px solid #ff0000'
  }
});



document.querySelector('#option_yes').addEventListener('click', () => {
  document.querySelector('.cstm_optionalGift').classList.remove('hidden');
  document.querySelector('#option_yes').classList.add('cstm-selected');
  document.querySelector('#option_no').classList.remove('cstm-selected');
});
document.querySelector('#option_no').addEventListener('click', () => {
  document.querySelector('.cstm_optionalGift').classList.add('hidden');
  document.querySelector('#option_yes').classList.remove('cstm-selected');
  document.querySelector('#option_no').classList.add('cstm-selected');
  giftText.value = "";
});
// personalizeBtn.addEventListener('click' , () => {
//       inputPropertyGift[0].value = optionstext;
//       inputPropertyGift[1].value = giftText.value;
// })

// <=================popup preview=============================>
var personalizePreviewBtn = document.querySelector('.cstm_previewBtn');
var previewPopup = document.querySelector('.main_personalise_preview');
var previewCut = document.querySelector('.main_personalise_preview .cross');
document.querySelector('body').addEventListener('click', (e) => {
  console.log("hiii", e);
  const element = e.target;
  if(element.classList.contains('cstm_previewBtn') || element.classList.contains('button_personalize')){
      previewPopup.classList.remove('hidden');
      QVpersonalizeBtn.setAttribute('disabled', true);
      document.querySelector('body').classList.add('overlayLook_personalization');
      document.querySelector('.cstm_page-overlay').classList.add('is-visible');
  }
});


previewCut.addEventListener('click', () => {
  previewPopup.classList.add('hidden');
  previewPopup.classList.add('animation');
  document.querySelector('body').classList.remove('overlayLook_personalization')
  document.querySelector('.cstm_page-overlay').classList.remove('is-visible')
  if (inputText.value.length == 0) {
       pdpPreviewText.innerHTML = "";
        pdpPreviewFont.innerHTML = "";
        pdpPreviewGift.innerHTML = "";
        pdpPreviewGiftYN.innerHTML = "";
  }
   if (giftText.value.length == 0) {
     pdpPreviewGift.innerHTML = "";
   }
});

confirmBtn.addEventListener('click' , () => {
  document.querySelector('body').classList.remove('overlayLook_personalization')
      if (inputText.value.length > 0) {
        previewPopup.classList.add('hidden');
        document.querySelector('.cstm_page-overlay').classList.remove('is-visible')  
        if (giftText.value.length > 0) {
          pdpPreviewGift.innerHTML = "<strong>Your Gift Message:</strong>" +  " " +  giftText.value;
        } else {
          pdpPreviewGift.innerText = "";
        }
      } else {
        inputText.focus();
        pdpPreviewText.innerText = "";
        pdpPreviewFont.innerText = "";
        pdpPreviewGift.innerText = "";
      }
    });